import { PolygonType } from '@/lib/enums/PolygonType'

export const FIELD_NAME = 'delivery_area_fees'

export const placeRuleTypes = {
  location: 'location',
  excluded: 'excluded',
}

export const isSpecialPriceArea = (area) => area?.polygon_type === PolygonType.Location.Value

export const countSpecialPriceAreas = (areas) =>
  areas.filter((area) => isSpecialPriceArea(area)).length

export const countExcludedAreas = (areas) =>
  areas.filter((area) => area?.polygon_type === PolygonType.Excluded.Value).length

export const normalizePlaceId = (placeId) => String(placeId ?? '').trim()
